/* eslint-disable no-unused-vars */
import { memo, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { ParagraphWithTooltip } from 'components';
import { Palette } from 'config';
import { ArrowDropDown } from 'assets/icons';

const statuses = {
  0: 'Active',
  1: 'Disabled',
};

export const TabContent = memo(
  ({
    name,
    bn_bannerid,
    status,
    showDropDownBtn,
    btnPressed$,
    btnRef,
    searchValue$,
    disabledBtn$,
  }) => {
    const handleClickBtn = (e) => {
      e.stopPropagation();
      if (!disabledBtn$.value) {
        btnPressed$.value = !btnPressed$.value;
        searchValue$.value = '';
      }
    };
    const isBannerId = useMemo(() => {
      if (typeof bn_bannerid === 'number') return true;
      return false;
    }, [bn_bannerid]);

    return (
      <Container>
        <Box showDropDownBtn={showDropDownBtn}>
          <StatusBox status={status}>{statuses[status]}</StatusBox>
          <ParagraphWithTooltip
            text={name || 'New creative'}
            style={{ fontSize: '16px', fontWeight: '500' }}
          />
          <ParagraphWithTooltip
            text={`ID: ${bn_bannerid}`}
            style={{
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '16px',
              visibility: `${!isBannerId && 'hidden'}`,
            }}
          />
        </Box>
        {showDropDownBtn && (
          <BtnContainer
            ref={btnRef}
            onClick={(e) => handleClickBtn(e)}
            btnPressed={btnPressed$.value}
            disabledBtn={disabledBtn$.value}
          >
            <ArrowDropDown />
          </BtnContainer>
        )}
      </Container>
    );
  },
);

TabContent.displayName = 'TabContent';

const BtnContainer = styled.div`
  width: 32px;
  border-radius: 4px;
  border: 1px solid ${Palette.PrimaryGray._200};
  background: white;
  display: grid;
  place-items: center;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
  ${({ disabledBtn }) =>
    disabledBtn &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
  ${({ btnPressed }) => {
    if (btnPressed)
      return css`
        border: 1px solid ${Palette.Primary._300};
        background: ${Palette.Primary._000};
        box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
        svg {
          fill: ${Palette.Primary._500};
          transform: rotate(180deg);
          transition: transform 0.2s linear;
        }
      `;
  }}
  svg {
    fill: ${Palette.PrimaryGray._500};
    transition: transform 0.2s linear;
  }
  :active {
    border: 1px solid ${Palette.Primary._300};
    background: ${Palette.Primary._000};
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
    svg {
      fill: ${Palette.Primary._500};
    }
  }
`;

const Container = styled.div`
  display: flex;
`;

const Box = styled.div`
  display: flex;
  justify-content: start;
  flex-direction: column;
  gap: 2px;

  width: ${({ showDropDownBtn }) => (showDropDownBtn ? '80%' : '100%')};
`;

const StatusBox = styled.p`
  ${({ status }) => {
    switch (status) {
      case 0:
        return css`
          color: ${Palette.Primary._500};
          border: 1px solid ${Palette.Primary._300};
          background: ${Palette.Primary._000};
        `;
      case 1:
        return css`
          color: ${Palette.PrimaryGray._500};
          border: 1px solid ${Palette.PrimaryGray._300};
          background: ${Palette.PrimaryGray._000};
        `;

      default:
        return '';
    }
  }}
  align-self: start;
  padding: 0 4px;
  border-radius: 2px;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  height: 16px;
`;
